/**
 * @desc 导出税务报表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsDeclarationDetails.exportDetails.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationDetails/exportDetails`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
